// Meoks: "Benzer ürünlere bak" popup
(function () {
  var modal = null;

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'meoks-similar-modal';
    modal.innerHTML = ''
      + '<div class="meoks-similar-modal__backdrop" data-close></div>'
      + '<div class="meoks-similar-modal__panel" role="dialog" aria-modal="true" aria-label="Benzer ürünler">'
      +   '<button type="button" class="meoks-similar-modal__close" data-close aria-label="Kapat">×</button>'
      +   '<div class="meoks-similar-modal__header"><h3 class="meoks-similar-modal__title">Benzer Ürünler</h3><p class="meoks-similar-modal__sub" data-sub></p></div>'
      +   '<div class="meoks-similar-modal__grid" data-grid><div class="meoks-similar-modal__loading">Yükleniyor…</div></div>'
      + '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-close')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return modal;
  }

  function open() {
    ensureModal();
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function renderProducts(products, size) {
    var grid = modal.querySelector('[data-grid]');
    if (!products.length) {
      grid.innerHTML = '<p style="text-align:center;color:#888;padding:40px;">Benzer ürün bulunamadı.</p>';
      return;
    }
    var html = products.slice(0, 12).map(function (p) {
      var img = p.image || p.featured_image || (p.images && p.images[0]) || '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      if (img && img.indexOf('?') === -1) img = img + '?width=400';
      var rawPrice = p.price_min || p.price;
      if (typeof rawPrice === 'string') rawPrice = parseFloat(rawPrice.replace(/[^\d.,]/g, '').replace(',', '.')) * 100;
      var amount = rawPrice >= 1000 ? rawPrice / 100 : rawPrice;
      var price = new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
      var vendor = p.vendor ? '<span class="meoks-similar-card__vendor">' + p.vendor + '</span>' : '';
      return ''
        + '<a href="' + p.url + '" class="meoks-similar-card">'
        +   '<div class="meoks-similar-card__img-wrap">' + (img ? '<img src="' + img + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') + '</div>'
        +   '<div class="meoks-similar-card__info">' + vendor + '<span class="meoks-similar-card__title">' + p.title + '</span><span class="meoks-similar-card__price">' + price + '</span></div>'
        + '</a>';
    }).join('');
    grid.innerHTML = html;
  }

  function fetchSimilar(vendor, type, productId, size) {
    var params = [];
    if (type) params.push('product_type:"' + type + '"');
    if (vendor) params.push('vendor:"' + vendor + '"');
    var q = params.join(' OR ');
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=20';
    return fetch(url).then(function (r) { return r.json(); }).then(function (d) {
      var products = (d.resources && d.resources.results && d.resources.results.products) || [];
      return products.filter(function (p) { return String(p.id) !== String(productId); });
    }).catch(function () { return []; });
  }

  function bind() {
    document.querySelectorAll('[data-meoks-similar]').forEach(function (a) {
      if (a.dataset.inited) return;
      a.dataset.inited = '1';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        ensureModal();
        var vendor = a.getAttribute('data-vendor');
        var type = a.getAttribute('data-type');
        var pid = a.getAttribute('data-product-id');
        var size = a.getAttribute('data-size');
        modal.querySelector('[data-sub]').textContent = size ? ('Beden ' + size + ' tükendi. Aynı kategoriden başka seçenekler:') : 'Aynı kategoriden seçenekler:';
        modal.querySelector('[data-grid]').innerHTML = '<div class="meoks-similar-modal__loading">Yükleniyor…</div>';
        open();
        fetchSimilar(vendor, type, pid, size).then(function (products) { renderProducts(products, size); });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  var __p = false;
  var __t = document.querySelector('.product-grid, results-list, main') || document.body;
  new MutationObserver(function () {
    if (__p) return; __p = true;
    (window.requestIdleCallback || window.requestAnimationFrame)(function () { __p = false; bind(); });
  }).observe(__t, { childList: true, subtree: true });
})();
